Object.defineProperty(exports, `foo`, {
  enumerable: true,
  get: function get() {
    return () => {}
  },
})
Object.defineProperty(exports, `__esModule`, {
  value: true,
})
